import { Link } from 'react-router-dom';
import { hotComics } from '@/mocks/comics';

export default function HotSeries() {
  return (
    <section className="max-w-[1440px] mx-auto px-4 md:px-6 py-14 md:py-20">
      <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-10 gap-4">
        <div>
          <span className="text-accent-600 text-xs font-semibold tracking-widest uppercase mb-2 block">本周热门</span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            热门连载
          </h2>
        </div>
        <p className="text-foreground-500 text-sm">每日零点更新 · 持续追更不停歇</p>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
        {hotComics.map((comic) => (
          <Link
            key={comic.id}
            to={`/comic/${comic.slug}`}
            className="group cursor-pointer"
          >
            <div className="relative aspect-[3/4] rounded-lg overflow-hidden mb-3">
              <img
                src={comic.coverUrl}
                alt={comic.title}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>

              <div className="absolute top-3 right-3">
                <span className="px-2.5 py-1 rounded-full bg-background-50/90 text-foreground-900 text-xs font-semibold whitespace-nowrap">
                  ★ {comic.rating}
                </span>
              </div>

              <div className="absolute bottom-0 left-0 right-0 p-4">
                <span className={`inline-block px-2 py-0.5 rounded text-xs font-medium mb-2 whitespace-nowrap ${
                  comic.status === '连载中' ? 'bg-primary-500/90 text-white' : 'bg-accent-500/90 text-white'
                }`}>
                  {comic.status}
                </span>
                <h3 className="text-white font-heading font-semibold text-base md:text-lg mb-1">
                  {comic.title}
                </h3>
                <p className="text-white/60 text-xs">{comic.latestChapter}</p>
              </div>
            </div>
            <p className="text-foreground-500 text-xs leading-relaxed line-clamp-2 px-0.5 group-hover:text-foreground-700 transition-colors">
              {comic.description}
            </p>
          </Link>
        ))}
      </div>
    </section>
  );
}